const auth = (
  state = {
    token: localStorage.getItem('token') || null,
    user: localStorage.getItem('user')?.length
      ? JSON.parse(localStorage.getItem('user'))
      : {},
  },
  action,
) => {
  switch (action.type) {
    case 'login': {
      localStorage.setItem('token', action.resp.token);
      localStorage.setItem('user', JSON.stringify(action.resp.user));

      return {
        token: action.resp.token,
        user: action.resp.user,
      };
    }

    case 'logout': {
      localStorage.removeItem('token');
      localStorage.removeItem('user');

      window.location.href = '/';

      return {
        token: null,
        user: {},
      };
    }

    case 'updateUser': {
      const updatedUser = { ...state.user, ...action.data };
      localStorage.setItem('user', JSON.stringify(updatedUser));

      return {
        ...state,
        user: updatedUser,
      };
    }

    default:
      return state;
  }
};

export default auth;
